import React from "react";

import {
  FaSearch,
  FaTimes,
} from "react-icons/fa";

export default function TutorialEmptyState({
  query,
  onClear,
}) {
  return (
    <div className="rounded-[28px] border border-dashed border-slate-300 bg-white p-8 text-center dark:border-slate-700 dark:bg-slate-900 sm:p-12">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[22px] bg-slate-100 text-2xl text-slate-400 dark:bg-slate-800">
        <FaSearch />
      </div>

      <h2 className="mt-5 text-xl font-bold text-slate-900 dark:text-white">
        Aucun résultat
      </h2>

      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun contenu ne correspond à
        la recherche « {query} ».
      </p>

      <button
        type="button"
        onClick={onClear}
        className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-violet-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-violet-700"
      >
        <FaTimes />
        Effacer la recherche
      </button>
    </div>
  );
}